import { apiCaller } from "src/util/apiCaller";
import configUrl from "src/util/config";

const getMeInfo = () => {
  const configAPI = {
    url: `${configUrl.API_URL}/api/me`,
    method: "GET",
    isShowMessage: false,
    data: null,
    params: null,
    apiType: "",
    getName: "userInfo",
  };
  const data = apiCaller(configAPI);
  return data || [];
};

export default getMeInfo;
